var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('header',{staticClass:"login-header"},[_vm._t("logo"),_vm._m(0)],2),_c('ForgotPasswordForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login-header-text"},[_c('h2',[_vm._v("Forgot your password?")]),_c('p',[_vm._v("No problem! Fill out the form below and we can send you a link to help you reset it.")])])
}]

export { render, staticRenderFns }